
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "EditableTitle587741278",
      {"classes":{"root":"EditableTitle587741278__root","heading-h1":"StylableTypography1240447049__heading-h1","heading-xl":"StylableTypography1240447049__heading-xl","headingWrapper":"EditableTitle587741278__headingWrapper","activationIndicator":"EditableTitle587741278__activationIndicator","renamingField":"EditableTitle587741278__renamingField","heading":"EditableTitle587741278__heading"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  